import { render, staticRenderFns } from "./DataExport.vue?vue&type=template&id=1312a8c8"
import script from "./DataExport.vue?vue&type=script&lang=js"
export * from "./DataExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports